import semver from 'semver';
export const isVersionedUrl = (url) => {
    if (!url.includes('unpkg.')) {
        return false;
    }
    const parts = url.split('@');
    return !!semver.clean(parts[parts.length - 1]);
};
//# sourceMappingURL=is-versioned-url.js.map